export type Region = {
  readonly display: string;
  readonly value: string;
};

export const Regions: Region[] = [
  {
    display: 'North America',
    value: 'NA',
  },
  {
    display: 'Europe',
    value: 'EU',
  },
  {
    display: 'Oceania',
    value: 'OC',
  },
  {
    display: 'Asia',
    value: 'AS',
  },
  {
    display: 'South America',
    value: 'SA',
  },
  {
    display: 'Africa',
    value: 'AF',
  },
];
